"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AddClassDefinitionGraphDialogModule = /** @class */ (function () {
    function AddClassDefinitionGraphDialogModule() {
    }
    return AddClassDefinitionGraphDialogModule;
}());
exports.AddClassDefinitionGraphDialogModule = AddClassDefinitionGraphDialogModule;
